import {
  asBoolean,
  asNumber,
  asString,
  FALLBACK_IMAGE_CARD,
  buildTrackAvailability,
  formatDuration,
  formatPlays,
  resolveArtistName,
  upscaleArtwork,
} from "./common";
import { createUserModel } from "./userModel";

function createFormatModel(format = {}) {
  return {
    protocolName: asString(format.protocol),
    mime_type: asString(format.mime_type),
  };
}

function createTranscodingModel(transcoding = {}) {
  return {
    url: asString(transcoding.url),
    preset: asString(transcoding.preset),
    duration: asNumber(transcoding.duration),
    snipped: asBoolean(transcoding.snipped),
    format: createFormatModel(transcoding.format),
    quality: asString(transcoding.quality),
  };
}

function createMediaModel(media = {}) {
  return {
    transcodings: Array.isArray(media.transcodings)
      ? media.transcodings.map(createTranscodingModel)
      : [],
  };
}

function createPublisherMetadataModel(metadata = {}) {
  if (!metadata || typeof metadata !== "object") return null;
  return {
    id: asNumber(metadata.id),
    urn: asString(metadata.urn),
    artist: asString(metadata.artist),
    album_title: asString(metadata.album_title),
    release_date: asString(metadata.release_date),
  };
}

export function createTrackModel(track = {}) {
  const artwork = asString(track.artwork_url);
  return {
    id: asNumber(track.id),
    kind: asString(track.kind),
    created_at: asString(track.created_at),
    last_modified: asString(track.last_modified),
    title: asString(track.title, "Untitled"),
    description: asString(track.description),
    duration: asNumber(track.duration),
    full_duration: asNumber(track.full_duration),
    commentable: asBoolean(track.commentable),
    comment_count: asNumber(track.comment_count),
    download_count: asNumber(track.download_count),
    playback_count: asNumber(track.playback_count),
    likes_count: asNumber(track.likes_count),
    reposts_count: asNumber(track.reposts_count),
    genre: asString(track.genre),
    tag_list: asString(track.tag_list),
    permalink_url: asString(track.permalink_url),
    artwork_url: artwork,
    hdArtworkURL: upscaleArtwork(artwork, "t500x500"),
    streamable: asBoolean(track.streamable),
    track_authorization: asString(track.track_authorization),
    user: createUserModel(track.user),
    media: createMediaModel(track.media),
    waveform_url: asString(track.waveform_url),
    publisher_metadata: createPublisherMetadataModel(track.publisher_metadata),
    policy: asString(track.policy),
  };
}

export function createTrackCardModel(track) {
  const normalized = createTrackModel(track);
  return {
    id: normalized.id,
    title: normalized.title,
    artist: resolveArtistName(normalized),
    duration: formatDuration(normalized.duration),
    image:
      normalized.hdArtworkURL ||
      upscaleArtwork(normalized.user?.avatar_url, "t500x500") ||
      FALLBACK_IMAGE_CARD,
    ...buildTrackAvailability(normalized),
    model: normalized,
  };
}

export function createTrackListModel(track) {
  const normalized = createTrackModel(track);
  return {
    id: normalized.id,
    title: normalized.title,
    artist: resolveArtistName(normalized),
    plays: formatPlays(normalized.playback_count),
    duration: formatDuration(normalized.duration),
    ...buildTrackAvailability(normalized),
    model: normalized,
  };
}
